import React, { useRef, useState } from 'react';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import { EditIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import { trimTitle } from '../../utils';
import styles from './DeviceChartEditableTitle.module.css';

function DeviceChartEditableTitle({ variant, editable, className, defaultValue }) {
  const {
    field: { value, onChange, onBlur },
    fieldState: { error }
  } = useController({ name: 'name' });
  const inputRef = useRef(null);
  const [editorVisible, setEditorVisible] = useState(false);
  const handleBlur = () => {
    const trimmedInputVal = trimTitle(inputRef.current.value);
    onChange(trimmedInputVal || defaultValue);
    onBlur();
    setEditorVisible(false);
  };
  const handleClick = () => {
    setEditorVisible(true);
  };

  return (
    <div
      className={classNames(styles.root, className, {
        [styles.config]: variant === 'config',
        [styles.history]: variant === 'history'
      })}
    >
      {editorVisible ? (
        <input
          ref={inputRef}
          className={styles.input}
          autoFocus={true}
          onBlur={handleBlur}
          defaultValue={value || defaultValue}
        />
      ) : (
        <div className={styles.container}>
          <div
            className={classNames(styles.title, {
              [styles.edited]: value.length > 0
            })}
          >
            {trimTitle(value || defaultValue)}
            {editable && (
              <IconButton aria-label="Edit" variant="link" color="secondary" size="x-small" onClick={handleClick}>
                <EditIcon />
              </IconButton>
            )}
          </div>
        </div>
      )}
      {error && <div className={styles.error}>{error.message}</div>}
    </div>
  );
}

export default DeviceChartEditableTitle;
